import { render } from "./DeletedRolesList.vue?vue&type=template&id=a5cefc12"
import script from "./DeletedRolesList.vue?vue&type=script&lang=js"
export * from "./DeletedRolesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__